import React from 'react';

import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Message } from 'primereact/message';

import { renderErrorTable } from './renderErrorTable';

interface ImportErrorDialogProps {
  errorDialogVisible: boolean;
  setErrorDialogVisible: React.Dispatch<React.SetStateAction<boolean>>;
  validationErrors: { error: string }[];
}

export const ImportErrorDialog: React.FC<ImportErrorDialogProps> = ({
  errorDialogVisible,
  setErrorDialogVisible,
  validationErrors
}) => {
  return (
    <Dialog
      header="Ошибка импорта"
      visible={errorDialogVisible}
      style={{ minWidth: '45vw', minHeight: 'auto' }}
      onHide={() => setErrorDialogVisible(false)}
    >
      {validationErrors.length > 0 ? (
        <div className="dialog-tabless-card">
          {renderErrorTable(validationErrors)}
          <Message
            severity="error"
            text="В импортируемом файле обнаружены ошибки, исправьте их и попробуйте загрузить снова"
          />
          <div className="default-card__buttons">
            <div className="flex gap-3">
              <Button
                label="Принять"
                icon="pi pi-check"
                onClick={() => setErrorDialogVisible(false)}
              />
            </div>
          </div>
        </div>
      ) : (
        <p>Ошибок не обнаружено.</p>
      )}
    </Dialog>
  );
};
